import { Input } from '@/components/ui/input';
import { useT } from '@/i18n/LanguageContext';

/**
 * <CategoryPicker> — カテゴリ / 分類 / 種別（仕様 2.1）。
 *
 * 既存の入力値を候補として出すだけ。統制の要求が出ていないので新しい
 * マスタは作らない（自由入力は自由入力のまま残す）。
 */
export const CategoryPicker = ({
  value = '', options = [], onChange, testId = 'category-picker',
  placeholder = null,
}) => {
  const { t } = useT();
  const listId = `${testId}-options`;
  return (
    <>
      <Input value={value || ''} onChange={(e) => onChange?.(e.target.value)} list={listId}
        placeholder={placeholder || t('reg.category.ph')} className="h-10 mt-1" data-testid={testId} />
      <datalist id={listId} data-testid={`${testId}-datalist`}>
        {(options || []).map((c) => {
          const name = typeof c === 'string' ? c : c.name;
          return name ? <option key={name} value={name} /> : null;
        })}
      </datalist>
    </>
  );
};

export default CategoryPicker;
